import {createContext, useEffect} from 'react'
import {THEMES} from './constant/Constant'
import useLocalStorage from './hook/useLocalStorage'
import {getDefaultLang, getSettings, isBroswerDarkMode} from './utils/utils'
import {changeLocale} from './utils/dateUtils'

// const broswerDarkMode = isBroswerDarkMode();
// const browserTheme = () => {
//   return broswerDarkMode ? THEMES.DARK : THEMES.LIGHT;
// }
// console.log(browserTheme(), 'canshu1')
const defaultLang = getDefaultLang()
const initialSettings = {
  direction: defaultLang === 'ar' ? 'rtl' : 'ltr',
  theme: THEMES.DARK,
  responsiveFontSizes: true,
  lang: defaultLang,
  email: '',
}
export const SettingsContext = createContext({
  settings: initialSettings,
  // saveSettings: (arg) => {
  // },
  updateSetting: () => {
  },
  // browserTheme: () => {},
}) // component props type

function SettingsProvider({
                            children,
                          }) {
  const {
    data: settings,
    storeData: setStoreSettings,
  } = useLocalStorage('settings', initialSettings)

  // const saveSettings = (updateSettings) => {
  //   setStoreSettings(updateSettings)
  // }

  const updateSetting = (updateSetting) => {
    setStoreSettings({
      ...settings,
      ...updateSetting,
    })
  }
  useEffect(() => {
    if (settings.lang) {
      changeLocale(settings.lang)
    }
  }, [settings.lang])

  return (
    <SettingsContext.Provider value={{
      settings: {...settings},
      // saveSettings,
      updateSetting,
      // browserTheme,
    }}>
      {children}
    </SettingsContext.Provider>
  )
}

export default SettingsProvider
